/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Button, Typography } from '@atoms';
import { MediaLibraryModal, ImageCrop } from '@molecules';
import { getSrc } from '@utils/media';

const CropImage = ({ onChangeImage, media, ...props }) => {
  return (
    <>
      <MediaLibraryModal.Heading style={{ alignItems: 'flex-start' }}>
        <MediaLibraryModal.Title
          extra={
            <Button type="customBlue" onClick={onChangeImage}>
              CHANGE IMAGE
            </Button>
          }
        >
          Crop image
        </MediaLibraryModal.Title>
      </MediaLibraryModal.Heading>

      <Typography.Paragraph>{media.fileName}</Typography.Paragraph>
      <ImageCrop src={getSrc({ media })} {...props} />
    </>
  );
};

export default CropImage;
